import { render } from "./a-mastertask-name.vue?vue&type=template&id=73ae31f9"
import script from "./a-mastertask-name.vue?vue&type=script&lang=js"
export * from "./a-mastertask-name.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__